import Swiper from 'swiper'
import { A11y, Keyboard, Navigation } from 'swiper/modules'

import Component, { loadComponent } from '../../../assets/scripts/modules/component.js'

const SWIPER_OPTIONS = {
  //createElements: true,
  slidesPerView: 1,
  spaceBetween: 0,
  loop: false,
  modules: [Navigation, Keyboard, A11y],
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  keyboard: {
    enabled: true,
    onlyInViewport: true,
    pageUpDown: false,
  },
  a11y: {
    enabled: true,
    scrollOnFocus: true,
  },
}

class ProductCarouselComponent extends Component {
  init() {
    this.swiperContainer = this.element.querySelector('.swiper')
    this.slideContainer = this.element.querySelector('.swiper-wrapper')

    if (!this.swiperContainer || !this.slideContainer) {
      return
    }

    this.swiper = null
    this.swiperOptions = { ...SWIPER_OPTIONS }

    if (this.swiperOptions.navigation) {
      this.swiperOptions.navigation.prevEl = this.element.querySelector('.swiper-button-prev')
      this.swiperOptions.navigation.nextEl = this.element.querySelector('.swiper-button-next')
    }

    if (this.swiper) {
      this.swiper.update()
    } else {
      this.swiper = new Swiper(this.swiperContainer, this.swiperOptions)
      this.swiper.update()
    }
  }
}

window.addEventListener('init-load', () => loadComponent(document, 'product-carousel', ProductCarouselComponent))
